import React from "react";
import BannerTitle from "../../common/components/BannerTitle";
import { GlobalContainer } from "../../common/components/Container";
import AppointmentsContainer from "./components/AppointmentsContainer";

const MyAppointments = () => {
  return (
    <GlobalContainer theme="white">
      <BannerTitle type="banner" theme="white">
        My Appointments
      </BannerTitle>
      <AppointmentsContainer />
    </GlobalContainer>
  );
};

export default MyAppointments;
